import { Box, Container, Grid, Paper } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import ItemDetailViewSection, {
  Item,
} from "../../../common/item/ItemDetailViewSection";
import PageHeading from "../../../common/pageHeading/PageHeading";
import useSession from "../../../effects/useSession";
import { getById } from "../../../store/possoftware/queries";
import { Data } from "../../../store/possoftware/types";
import Layout from "../../Layout";
import pageStyles from "../../pageStyles";

const PosSoftwareView = () => {
  const classes = pageStyles();
  const session = useSession();

  const { id } = useParams<{ id: string }>();
  const posSoftware = useSelector(id ? getById(id) : () => null) as Data;
  const { attributes: at } = posSoftware;

  const posSoftwareInfo: Item[] = [
    {
      fieldName: "Provider Identification",
      fieldValue: at.ProviderIdentification,
    },
    {
      fieldName: "Application Name",
      fieldValue: at.ApplicationName,
    },
    {
      fieldName: "Certification Code",
      fieldValue: at.CertificationCode,
    },
    {
      fieldName: "Software Versions",
      fieldValue: at.SoftwareVersion,
    },
    {
      fieldName: "KEK",
      fieldValue: at.KEK,
    },
    {
      fieldName: "KEK Identifier",
      fieldValue: at.KEKIdentifier,
    },
    {
      fieldName: "KEK Version",
      fieldValue: at.KEKVersion,
    },
  ];

  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading heading="View POS SoftWare" />
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <Box style={{ position: "relative" }}>
                  <ItemDetailViewSection
                    sectionName="POS SoftWare Info"
                    itemData={posSoftwareInfo}
                    lastItem
                  />
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
};

export default PosSoftwareView;
